import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { CustomerAddressData } from '../entities/customer-address-data.model';
import { KryptoOnboardingStatusData } from '../entities/krypto-onboarding-status-data.model';

@Injectable({ providedIn: 'root' })
export class CryptoOnboardingInfrastructure {
  private readonly statusUrl = '/api/kryptoonboarding/status';
  private readonly acceptConditionsUrl = '/api/kryptoonboarding/acceptconditions';
  private readonly loadAddressDataUrl = '/api/kryptoonboarding/address';

  constructor(private _http: HttpClient) {}

  public getOnboardingStatus(): Observable<KryptoOnboardingStatusData> {
    return this._http.get<KryptoOnboardingStatusData>(environment.apihost + this.statusUrl);
  }

  public postAcceptConditions(): Observable<KryptoOnboardingStatusData> {
    return this._http.post<KryptoOnboardingStatusData>(environment.apihost + this.acceptConditionsUrl, null);
  }

  public getCustomerAddress(): Observable<CustomerAddressData> {
    return this._http.get<CustomerAddressData>(environment.apihost + this.loadAddressDataUrl);
  }
}
